import {
  ADD_LEADS,
  REMOVE_LEADS,
  SET_CURRENT_PAGE,
  IndividualListActionTypes,
  RESET_LEADS_LIST,
} from '../actions/individuallist.actions';

interface ListObj {
  listId: string;
  checkedItems: any[];
  userIds: any[];
  currentPage: number;
}

const initialState: ListObj[] = [];

const getList = (state: any, action: IndividualListActionTypes) =>
  state.filter((list: any) => list.listId === action.payload.listId);

export const IndividualListReducer = (
  state = initialState,
  action: IndividualListActionTypes
) => {
  switch (action.type) {
    case ADD_LEADS: {
      let list = getList(state, action);
      return list && list.length > 0
        ? state.map((list: any) =>
            list.listId === action.payload.listId
              ? {
                  ...list,
                  checkedItems: [
                    ...list.checkedItems,
                    ...action.payload.userKey,
                  ],
                  userIds: [...list.userIds, ...action.payload.userId],
                }
              : list
          )
        : [
            ...state,
            {
              listId: action.payload.listId,
              checkedItems: [...action.payload.userKey],
              userIds: [...action.payload.userId],
              currentPage: 1,
            },
          ];
    }
    case REMOVE_LEADS: {
      let list = getList(state, action);

      return list && list.length > 0
        ? state.map((list: any) =>
            list.listId === action.payload.listId
              ? {
                  ...list,
                  checkedItems: list.checkedItems.filter(
                    (userKey: any) => !action.payload.userKey.includes(userKey)
                  ),
                  userIds: list.userIds.filter(
                    (userId: any) => !action.payload.userId.includes(userId)
                  ),
                }
              : list
          )
        : [
            ...state,
            {
              listId: action.payload.listId,
              //@ts-ignore
              checkedItems: [],
              userIds: [],
              currentPage: action.payload.currentPage,
            },
          ];
    }
    case SET_CURRENT_PAGE: {
      let list = getList(state, action);
      return list && list.length > 0
        ? state.map((list: any) =>
            list.listId === action.payload.listId
              ? {
                  ...list,
                  currentPage: action.payload.currentPage,
                }
              : list
          )
        : [
            ...state,
            {
              listId: action.payload.listId,
              //@ts-ignore
              checkedItems: [],
              userIds: [],
              currentPage: action.payload.currentPage,
            },
          ];
    }
    case RESET_LEADS_LIST:
      //Only clear the state if it's populated
      let { viewType = 'explore' } = action.payload;

      //set it to toLocaleLowerCase
      viewType = viewType.toLocaleLowerCase();
      switch (viewType) {
        case 'all': //Clear state completely
          return initialState;
        default:
          /*
          NOTE: -1 is the default id given to a table when viewed from the Explore View

          based on action.payload.viewType
          viewType === "Explore"
            Remove all lists that do not have an id of -1
          viewType === "Lists"
            Remove the one list with an id of -1
         */
          return state.length > 0
            ? state.filter(list =>
                viewType === 'explore'
                  ? list.listId !== '-1'
                  : list.listId === '-1'
              )
            : state;
      }
    default:
      return state;
  }
};
